<template>
    <LoadingSpinner v-if="loadingStatus || loading" />
    <div id="pqPopup"></div>
    <DxPopup v-model:visible="popup.visible"
             :title="popup.title"
             width="auto"
             height="auto"
             container="#pqPopup"
             :content-template="popup.template">
        <template #statusChange>
            <div class="puChangeState">
                <div class="puChangeStateMessage" v-html="popup.message">
                </div>
                <div class="puChangeMessage" v-if="popup.hasChangeNotification">
                    <div class="puChangeStateMailTitle">Email Message:</div>
                    <div class="puChangeStateMail">
                        <DxHtmlEditor v-model:value="popup.mailText"
                                      value-type="html"
                                      ref="EmailEditor"
                                      :height="200"
                                      class="html-dx-field">
                            <DxToolbar>
                                <DxItem name="undo" />
                                <DxItem name="redo" />
                                <DxItem name="separator" />
                                <DxItem name="bold" />
                                <DxItem name="italic" />
                                <DxItem name="strike" />
                                <DxItem name="underline" />
                                <DxItem name="separator" />
                                <DxItem name="alignLeft" />
                                <DxItem name="alignCenter" />
                                <DxItem name="alignRight" />
                                <DxItem name="alignJustify" />
                                <DxItem name="separator" />
                                <DxItem name="color" />
                                <DxItem name="background" />
                            </DxToolbar>
                        </DxHtmlEditor>
                    </div>
                </div>
                <div class="assigneeSelection" v-if="popup.showAssigneeSelection">
                    <div class="assigneeSelectionLabel">Select Assignee:</div>
                    <div class="assigneeSelectionValue">
                        <DxSelectBox :data-source="popup.assigneeList"
                                     :show-clear-button="true"
                                     search-mode="contains"
                                     display-expr="UsrFullName"
                                     select-all-mode="allPages"
                                     value-expr="UsrId"
                                     :search-enabled="true"
                                     placeholder="Choose Assignee"
                                     v-model:value="selectedUsrIdForAction">
                        </DxSelectBox>
                    </div>
                </div>
                <div class="expertsSelection" v-if="popup.showExpertsSelection">
                    <div class="assigneeSelectionLabel">Send an email to Reviewer:</div>
                    <div class="assigneeSelectionValue">
                        <DxTagBox :data-source="popup.expertsListForGroup"
                                  :show-selection-controls="true"
                                  :show-clear-button="true"
                                  display-expr="UsrFullName"
                                  value-expr="UsrId"
                                  :search-enabled="true"
                                  placeholder="Choose Expert"
                                  v-model:selected-items="selectedExperts">
                        </DxTagBox>
                    </div>
                </div>

                <div class="puChangeStateButtons">
                    <div class="puChangeStateButton">
                        <DxButton text="Cancel"
                                  @click="popupChangeStateCancel"
                                  type="default"></DxButton>
                    </div>
                    <div class="puChangeStateButton">
                        <DxButton text="OK"
                                  @click="changeStateOnServer"
                                  type="success"></DxButton>
                    </div>
                </div>
            </div>
        </template>
    </DxPopup>

</template>

<script>
    import LoadingSpinner from "@/views/widgets/LoadingSpinner";
    import { DxPopup } from 'devextreme-vue/popup';
    import { DxHtmlEditor, DxItem, DxToolbar } from 'devextreme-vue/html-editor';
    import { DxSelectBox } from 'devextreme-vue/select-box';
    import { DxTagBox } from 'devextreme-vue/tag-box';
    import { DxButton } from 'devextreme-vue/button';
    import { nextTick } from 'vue';
    import { alert } from "devextreme/ui/dialog"
    export default {
        name: "ChangeTopicStatusPopup",
        components: {
            LoadingSpinner,
            DxPopup,
            DxHtmlEditor,
            DxItem,
            DxToolbar,
            DxSelectBox,
            DxTagBox,
            DxButton
        },
        data() {
            return {
                linkMode: true,
                topicId: 0,
                tliId: 0,
                popup: {
                    visible: false,
                    template: "",
                    title: "",
                    message: "",
                    hasChangeNotification: false,
                    showAssigneeSelection: false,
                    showExpertsSelection: false,
                    assigneeList: [],
                    expertsListForGroup: [],
                    expertsGrpId: 0,
                    mailText: "",
                },
                selectedUsrIdForAction: null,
                selectedExperts: [],
                statusId: null,
                loading: false
            };
        },

        created() {
        },
        computed: {
            args() {
                let uri = window.location.search.substring(1);
                let params = new URLSearchParams(uri);
                return params.get("args");
            },
        },
        watch: {
        },
        methods: {
            showTopicPopup(topicId, statusId) {
                this.topicId = topicId;
                this.linkMode = false;
                this.$store.dispatch("getStatusInfo", { statusId }).then(res => {
                    if (res.data.success) {
                        this.showChangeStatusPopup(topicId, res.data.status);
                    }
                    else {
                        alert("An error occurred while getting status info.");
                    }
                });
            },
            showTopicLinkPopup(topicId, tliId, statusId) {
                this.topicId = topicId;
                this.tliId = tliId;
                this.linkMode = true;
                return this.$store.dispatch("getStatusInfo", { statusId }).then(res => {
                    if (res.data.success) {
                        return this.showChangeStatusPopup(topicId, res.data.status);
                    }
                    else {
                        return alert("An error occurred while getting status info.");
                    }
                });
            },
            showChangeStatusPopup: function (topicId, status) {
                this.popup.message = ""
                this.popup.showAssigneeSelection = false
                this.popup.showExpertsSelection = false
                this.selectedUsrIdForAction = null
                this.topicId = topicId
                if (status) {
                    let msg = status.ActionButtonMessage && status.ActionButtonMessage.length > 0
                        ? status.ActionButtonMessage
                        : "Are you sure you want to change the status?";
                    this.popup.template = "statusChange"
                    this.popup.title = "Change Status";
                    this.popup.message = msg
                    this.actionButtonMessage = msg
                    this.selectedUsrIdForAction = null
                    this.statusId = status.StatusID
                    this.popup.showAssigneeSelection = status.GrpId > 0
                    this.popup.showExpertsSelection = status.NroId == 9
                    this.popup.expertsGrpId = status.NroId == 9 ? status.ExpertGrpId : -1
                    if (status.ConfirmAction) {
                        if (status.NevId > 0 && status.ConfirmMail) {
                            this.loading = true
                            this.popup.hasChangeNotification = true
                            Promise.all([
                                this.$store.dispatch("getParsedNotification", { topicId: this.topicId, nevId: status.NevId, args: this.args }),
                                this.$store.dispatch("getUserListForGroup", { grpId: status.GrpId }),
                                this.$store.dispatch("getUserListForGroup", { grpId: this.popup.expertsGrpId })
                            ]).then(res => {
                                this.loading = false
                                if (res[0].success && res[1].success && res[2].success) {
                                    this.popup.mailText = res[0].data.Message;
                                    this.popup.visible = true;
                                    this.popup.assigneeList = res[1].data
                                    this.popup.expertsListForGroup = res[2].data
                                }
                            })
                        }
                        else {
                            this.popup.hasChangeNotification = false
                            if (status.GrpId > 0) {
                                this.$store.dispatch("getUserListForGroup", { grpId: status.GrpId })
                                    .then(() => {
                                        this.popup.visible = true;
                                    })
                            }
                            else {
                                this.popup.visible = true;
                            }
                        }
                    }
                    else {
                        this.popup.mailText = ""
                        this.changeStateOnServer();
                    }
                }
            },
            popupChangeStateCancel: function () {
                this.popup.visible = false;
            },
            changeStateOnServer: function () {
                nextTick(() => {
                    var msg = this.$refs.EmailEditor ? this.$refs.EmailEditor.instance._getContent()[0].innerHTML : ""
                    this.loading = true
                    const action = this.linkMode ? "changeTopicLinkStatus" : "changeTopicStatus";
                    this.$store.dispatch(action, {
                        topicId: this.topicId,
                        tliId: this.tliId,
                        statusId: this.statusId,
                        assigneeId: this.selectedUsrIdForAction,
                        expertIds: this.selectedExperts.map(m => m.UsrId),
                        mailText: msg
                    }).then(res => {
                        if (res.success) {
                            this.popup.visible = false;
                            this.isToastVisible = true
                            this.toastMessage = "Status successfully changed"
                            this.loading = false;
                            if (this.linkMode) {
                                this.$emit('statusTopicLinkChanged');
                            }
                            else {
                                this.$emit('statusChanged');
                            }                        
                        }
                        else {
                            this.loading = false 
                            alert("Error on Changing Status", "Error").then(() => {
                                this.popup.visible = false;
                            })
                        }
                        return res;
                    })
                })
            },
        }
    };
</script>



<style scoped>
    .crmCaption {
        font-size: 13px;
    }

    .echBox {
        font-size: 10px;
        gap: 10px;
        margin-top: 10px;
    }

    .nodes {
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
        width: 100%;
        border-bottom: solid 1px rgb( 223, 223, 224);
    }

        .nodes:hover {
            cursor: pointer;
            color: var(--m02-color-1)
        }

    span {
        padding-right: 5px;
    }
</style>